import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons/faCheckCircle'

type Props = {
    isSubmitted: boolean
}

const FormCheck = ({isSubmitted}: Props) => {
    return (
        <>
            {isSubmitted && (
                <FontAwesomeIcon
                    icon={faCheckCircle}
                    className={'has-text-success forms__check'}
                    style={{fontSize: '8rem', marginBottom: '1.25rem'}}
                />
            )}
        </>
    )
}

export default FormCheck
